import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL , CACHED_BASE_URL } from '../commonConfig/ApiConfig';

// Async thunk for tier data API call
export const fetchTierData = createAsyncThunk(
  'map/fetchTierData',
  async ({ geo_level, parent_lgd_code, searchType }, { rejectWithValue }) => {
    try {
      const payload = {
        geo_level,
        parent_lgd_code,
        data: {
          search: "",
          searchType: searchType
        }
      };
      const response = await axios.post(`${BASE_URL}locations/search`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Async thunk for hierarchy data API call (FIXED)
export const fetchHierarchyData = createAsyncThunk(
  'map/fetchHierarchyData',
  async ({ geo_level, lgd_code }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${CACHED_BASE_URL}locations/hierarchy`, {
        params: {
          geo_level: geo_level,
          lgd_code: lgd_code
        }
      });
      return response.data.locations;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const LocationSlice = createSlice({
  name: 'map',
  initialState: {
    geoJsonData: null,
    tierLocations: {},
    hierarchyData: {
      state: [],
      district: []
    },
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Tier data cases
      .addCase(fetchTierData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTierData.fulfilled, (state, action) => {
        state.loading = false;
        const searchType = action.meta.arg.searchType;
        const locations = action.payload.locations || [];
        state.tierLocations[searchType] = locations;
      })
      .addCase(fetchTierData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Hierarchy data cases
      .addCase(fetchHierarchyData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHierarchyData.fulfilled, (state, action) => {
        state.loading = false;
        state.hierarchyData = action.payload;
      })
      .addCase(fetchHierarchyData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default LocationSlice.reducer;